(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["add-to-cart"] && !Shopify.designMode) return;
  try {
    /*
    Suivi de l'offre Moonbundle dans la pastille de prix du bouton.

    Le module d'offres (offres 1 / 3 / 5 boîtes) est affiché au-dessus du bouton. Quand le client
    change d'offre, la pastille reprend le prix total et le prix barré de l'offre sélectionnée
    (3 boîtes : 89,97 € barré, 59,99 €). Sans module d'offres, la pastille garde le prix de la
    variante rendu en Liquid.

    Règle d'or : ne jamais afficher un prix qui contredit l'offre choisie. Dans le doute, la
    pastille est masquée ; elle ne retombe jamais sur le prix d'une seule boîte quand une offre
    est affichée.

    Où lire le prix, dans l'ordre :
    0. L'état publié par Moonbundle (moonbundle-v4) : window.MoonBundle[id de <moonbundle-component>]
       expose des magasins Svelte « config » (offers[id].isSelected) et « prices » (par offre :
       totalWithUpsellsDiscountedPriceFormatted et totalWithUpsellsOriginalPriceFormatted, les
       mêmes valeurs que Moonbundle écrit dans le prix du thème quand themePrice.sync est actif).
       C'est la source principale : elle ne dépend pas du balisage du module. Tant qu'un
       <moonbundle-component> est présent sans que cet état soit prêt, la pastille reste masquée.
    1. Le module lui-même (racine .moonbundle-box), avec les classes documentées par Moonbundle :
       - l'offre sélectionnée : .moonbundle-option.moonbundle-option-active ; à défaut, la
         .moonbundle-option dont le bouton radio est coché ;
       - son bloc de prix : le premier .moonbundle-option-price qui n'est ni le prix barré
         (.moonbundle-option-old-price) ni un prix unitaire (.moonbundle-option-each-price,
         .moonbundle-option-single-price), ni placé dans l'un d'eux, ni barré (<s>, <del>) : ces
         nœuds peuvent porter aussi la classe du bloc de prix. Cherché dans la ligne de l'offre,
         puis dans son enveloppe .moonbundle-option-wrapper ;
       - dans ce bloc, prix barré, prix unitaires et textes barrés sont retirés, et les montants
         d'une remise (« Économisez 29,98 € », « -29,98 € », « 29,98 € d'économie ») sont
         ignorés ;
       - son prix barré : le premier .moonbundle-option-old-price hors prix unitaire.
       Le module est cherché dans la section et, s'il en a une, dans la racine fantôme ouverte de
       <moonbundle-component>.
    2. Module présent mais illisible : le bloc « Prix » d'Horizon (product-price .price), mais
       seulement quand on sait que Moonbundle le synchronise (réglage themePrice.sync), c'est-à-dire
       quand il affiche, ou a affiché pendant la visite, un autre montant que le prix de la variante.
    3. Module présent, illisible, et prix du thème non synchronisé : pastille masquée
       (data-nf-source="en-attente"), jusqu'à ce qu'un prix fiable soit lu.
    4. Sans module d'offres : le prix de la variante (attributs data-nf-base-* de la pastille).

    Le prix lu est converti en centimes puis réécrit avec le format monétaire de la boutique, pour
    garder exactement la même écriture que les prix Liquid. Garde-fou : un montant plus de 50 fois
    supérieur au prix de la variante (par exemple des centimes affichés en exposant, lus « 5999 »)
    est jugé illisible, et l'on passe à la source suivante plutôt que d'afficher un prix faux.
    Diagnostic : data-nf-source de .nf-atc__pill vaut « offre », « prix-du-theme », « en-attente »
    ou « variante ».

    Mise à jour : un MutationObserver surveille la section (changement d'offre, affichage tardif du
    module, morph du bouton par Horizon, réécriture du prix par Moonbundle), doublé d'une écoute des
    clics et des changements de choix dans la section ; le calcul est relancé au plus une fois par
    image. Chaque écriture n'a lieu que si la valeur change : pas de boucle.
  */
  if (!customElements.get('nf-atc-offer-sync')) {
    const MB_HOST = 'moonbundle-component';
    const MB_BOX = '.moonbundle-box';
    const MB_OPTION = '.moonbundle-option';
    const MB_WRAPPER = '.moonbundle-option-wrapper';
    const MB_ACTIVE = '.moonbundle-option.moonbundle-option-active';
    const MB_ACTIVE_LOOSE = '.moonbundle-option-active';
    const MB_CHECKED = 'input:checked, [aria-checked="true"], [aria-selected="true"]';
    const MB_PRICE = '.moonbundle-option-price';
    const MB_OLD = '.moonbundle-option-old-price';
    const MB_PER_UNIT = '.moonbundle-option-each-price, .moonbundle-option-single-price';
    // Jamais le prix à payer : prix barré, prix unitaire, texte barré.
    const NOT_MAIN = MB_OLD + ', ' + MB_PER_UNIT + ', s, del, strike';
    const THEME_PRICE = 'product-price .price';
    const THEME_COMPARE = 'product-price .compare-at-price';

    // Garde-fou : au-delà de 50 fois le prix de la variante, le montant lu est jugé illisible.
    const MAX_RATIO = 50;

    // Attente de l'état Moonbundle : 60 essais espacés de 250 ms (15 s) au plus.
    const STORE_TRIES = 60;
    const STORE_DELAY = 250;

    const OBSERVE = {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'aria-checked', 'aria-selected', 'checked'],
    };

    // Un montant : 59,99 · 1 234,56 · 1.234,56 · 1,234.56 · 60
    const AMOUNT =
      "\\d{1,3}(?:[ \\u00a0\\u202f.,']\\d{3})+(?:[.,]\\d{1,2})?(?!\\d)|\\d+(?:[.,]\\d{1,2})?(?!\\d)";
    const PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;

    const decoder = document.createElement('textarea');

    // Texte brut : entités décodées (&euro;, &nbsp;), balises retirées.
    const clean = (value) => {
      decoder.innerHTML = String(value || '');
      return decoder.value.replace(/<[^>]*>/g, '').trim();
    };

    const escapeRegExp = (value) => value.replace(/[.*+?^$()|[\]\\]/g, '\\$&').replace(/[{}]/g, '\\$&');

    // Montant encadré par le symbole monétaire de la boutique (ex. « 59,99 € ») : évite de prendre
    // un pourcentage ou une quantité pour un prix.
    const moneyPattern = (format) => {
      const parts = format.split(PLACEHOLDER);
      if (parts.length < 3) return null;
      const before = escapeRegExp(parts[0].trim());
      const after = escapeRegExp(parts[2].trim());
      if (!before && !after) return null;
      return new RegExp((before ? before + '\\s*' : '') + '(' + AMOUNT + ')' + (after ? '\\s*' + after : ''), 'g');
    };

    const toCents = (token) => {
      const decimals = token.match(/[.,](\d{1,2})$/);
      if (decimals) {
        const whole = token.slice(0, -decimals[0].length).replace(/\D/g, '');
        return parseInt(whole || '0', 10) * 100 + parseInt((decimals[1] + '0').slice(0, 2), 10);
      }
      return parseInt(token.replace(/\D/g, ''), 10) * 100;
    };

    // Montant d'une remise, pas d'un prix à payer : « Économisez 29,98 € », « Vous économisez
    // jusqu'à 29,98 € », « -29,98 € », « 29,98 € d'économie », « 7,99 € offerts ». « Offre
    // économique » ou « Prix après remise » ne sont pas visés.
    const SAVING_BEFORE = /[\u00c9\u00e9Ee]conomi[es]|[\u00c9\u00e9Ee]pargn|rabais|gagne|remise de|r[\u00e9e]duction de|\bsave|saving/i;
    const MINUS_BEFORE = /(?:^|[\s(])[-\u2212]$/;
    const SAVING_AFTER =
      /^[\s\u00a0\u202f]*(?:d['\u2019][\s\u00a0\u202f]*)?(?:[\u00c9\u00e9Ee]conomi[es]|offert|gratuit|de remise|de r[\u00e9e]duction|saved|off\b)/i;

    // Premier montant du texte, en centimes. Les prix unitaires (« 19,99 € / boîte »), les
    // pourcentages, les quantités (« x3 ») et les montants d'une remise sont ignorés.
    const firstAmount = (text, patterns) => {
      const value = String(text || '');
      for (const pattern of patterns) {
        if (!pattern) continue;
        pattern.lastIndex = 0;
        let previous = 0;
        let match;
        while ((match = pattern.exec(value))) {
          // Texte entre le montant précédent et celui-ci, réduit à ce qui suit le dernier chiffre,
          // « % » ou séparateur : le contexte immédiat du montant.
          const lead = value.slice(previous, match.index).split(/[\d%:|\u2022\u00b7\n]/).pop();
          previous = match.index + match[0].length;
          const rest = value.slice(previous);
          const after = rest.match(SAVING_AFTER);
          if (after) {
            // « 29,98 € d'économie » : la formule appartient à ce montant, pas au suivant.
            previous += after[0].length;
            continue;
          }
          if (/[A-Za-z\u00d7]/.test(value.charAt(match.index - 1))) continue;
          if (/^[\s\u00a0\u202f]*[^\d\s\/]{0,4}[\s\u00a0\u202f]*[\/%]/.test(rest)) continue;
          if (SAVING_BEFORE.test(lead) || MINUS_BEFORE.test(lead)) continue;
          const cents = toCents(match[1] || match[0]);
          if (cents > 0 && Number.isFinite(cents)) return cents;
        }
      }
      return null;
    };

    // Le nœud, ou l'un de ses parents jusqu'à « stop » exclu, correspond-il au sélecteur ?
    const within = (node, stop, selector) => {
      for (let el = node; el && el !== stop; el = el.parentElement) {
        if (el.matches(selector)) return true;
      }
      return false;
    };

    // Premier nœud de « zone » qui correspond à « selector » sans être un nœud « excluded » ni
    // être placé dans l'un d'eux.
    const pick = (zone, selector, excluded) => {
      for (const node of zone.querySelectorAll(selector)) {
        if (!within(node, zone, excluded)) return node;
      }
      return null;
    };

    const delimit = (cents, precision, thousands, decimal) => {
      const fixed = (cents / 100).toFixed(precision).split('.');
      const whole = fixed[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return fixed[1] ? whole + decimal + fixed[1] : whole;
    };

    // Même écriture que le filtre Liquid money, à partir du format de la boutique.
    const formatMoney = (cents, format) => {
      const match = format.match(PLACEHOLDER);
      const styles = {
        amount: [2, ',', '.'],
        amount_no_decimals: [0, ',', '.'],
        amount_with_comma_separator: [2, '.', ','],
        amount_no_decimals_with_comma_separator: [0, '.', ','],
        amount_with_apostrophe_separator: [2, "'", '.'],
        amount_no_decimals_with_space_separator: [0, ' ', ''],
        amount_with_space_separator: [2, ' ', ','],
        amount_with_period_and_space_separator: [2, ' ', '.'],
      };
      const style = (match && styles[match[1]]) || styles.amount_with_comma_separator;
      const value = delimit(cents, style[0], style[1], style[2]);
      return match ? format.replace(PLACEHOLDER, value) : value;
    };

    class NfAtcOfferSync extends HTMLElement {
      connectedCallback() {
        this.host = this.closest('add-to-cart-component') || this.parentElement;
        this.scope = this.closest('.shopify-section, dialog') || document.body;
        this.format = clean(this.dataset.moneyFormat);
        this.patterns = [moneyPattern(this.format), new RegExp(AMOUNT, 'g')];
        this.frame = 0;
        // Devient vrai dès que le prix du thème diffère du prix de la variante : Moonbundle le
        // synchronise alors avec l'offre choisie, on peut s'y fier jusqu'à la fin de la visite.
        this.themeSynced = false;
        this.watched = new WeakSet();
        // Abonnement aux magasins Moonbundle (source 0).
        this.storeStops = [];
        this.storeId = null;
        this.storeState = { config: null, prices: null };
        this.storeTries = 0;
        this.storeTimer = 0;
        this.observer = new MutationObserver(() => this.schedule());
        this.observer.observe(this.scope, OBSERVE);
        // Filet en plus de l'observateur : un clic ou un changement de choix dans la section relance
        // aussi le calcul (cas d'un module qui ne marquerait l'offre choisie que par un style en
        // ligne ou par l'état coché d'un bouton radio, invisibles pour le MutationObserver).
        this.onInput = () => this.schedule();
        this.scope.addEventListener('click', this.onInput, true);
        this.scope.addEventListener('change', this.onInput, true);
        this.schedule();
      }

      disconnectedCallback() {
        if (this.scope && this.onInput) {
          this.scope.removeEventListener('click', this.onInput, true);
          this.scope.removeEventListener('change', this.onInput, true);
        }
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
        if (this.storeTimer) clearTimeout(this.storeTimer);
        this.storeTimer = 0;
        this.unhookStore();
      }

      // <moonbundle-component> de la section (à défaut, de la page).
      storeHosts() {
        const hosts = this.scope.querySelectorAll(MB_HOST);
        return hosts.length ? hosts : document.querySelectorAll(MB_HOST);
      }

      hookStore(id, entry) {
        this.unhookStore();
        this.storeId = id;
        const listen = (key) => (value) => {
          this.storeState[key] = value;
          this.schedule();
        };
        try {
          // Un magasin Svelte appelle l'abonné tout de suite avec sa valeur courante.
          this.storeStops.push(entry.config.subscribe(listen('config')));
          this.storeStops.push(entry.prices.subscribe(listen('prices')));
        } catch (error) {
          this.unhookStore();
        }
      }

      unhookStore() {
        (this.storeStops || []).forEach((stop) => {
          try {
            if (typeof stop === 'function') stop();
            else if (stop && typeof stop.unsubscribe === 'function') stop.unsubscribe();
          } catch (error) {
            /* abonnement déjà fermé */
          }
        });
        this.storeStops = [];
        this.storeId = null;
        this.storeState = { config: null, prices: null };
      }

      retryStore() {
        if (this.storeTimer || this.storeTries >= STORE_TRIES || !this.observer) return;
        this.storeTries += 1;
        this.storeTimer = setTimeout(() => {
          this.storeTimer = 0;
          this.schedule();
        }, STORE_DELAY);
      }

      // Montant d'un prix Moonbundle en centimes : le texte formaté d'abord, sinon la valeur
      // numérique (entier = centimes, décimal = euros).
      storeAmount(formatted, raw, limit) {
        let cents = formatted ? firstAmount(clean(formatted), this.patterns) : null;
        if (!cents && typeof raw === 'number' && Number.isFinite(raw) && raw > 0) {
          cents = Number.isInteger(raw) ? raw : Math.round(raw * 100);
        }
        return cents && (!limit || cents <= limit) ? cents : null;
      }

      // Source 0 : état publié par Moonbundle. Renvoie null s'il n'est pas (encore) disponible.
      readStore(limit) {
        const registry = window.MoonBundle;
        let id = null;
        let entry = null;
        for (const host of this.storeHosts()) {
          const candidate = registry && host.id ? registry[host.id] : null;
          if (
            candidate &&
            candidate.config &&
            candidate.prices &&
            typeof candidate.config.subscribe === 'function' &&
            typeof candidate.prices.subscribe === 'function'
          ) {
            id = host.id;
            entry = candidate;
            break;
          }
        }
        if (!entry) {
          if (this.storeId) this.unhookStore();
          this.retryStore();
          return null;
        }
        if (this.storeId !== id) this.hookStore(id, entry);

        const offers = this.storeState.config && this.storeState.config.offers;
        const prices = this.storeState.prices;
        if (!offers || !prices) return null;
        const selected = Object.keys(offers).find((key) => offers[key] && offers[key].isSelected === true);
        const data = selected ? prices[selected] : null;
        if (!data) return null;

        const price = this.storeAmount(
          data.totalWithUpsellsDiscountedPriceFormatted,
          data.totalWithUpsellsDiscountedPrice,
          limit
        );
        if (!price) return null;
        const compare = this.storeAmount(
          data.totalWithUpsellsOriginalPriceFormatted,
          data.totalWithUpsellsOriginalPrice,
          limit
        );
        return { source: 'offre', price: price, compare: compare && compare > price ? compare : null };
      }

      schedule() {
        if (this.frame || !this.observer) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      }

      // La section, plus la racine fantôme ouverte de chaque <moonbundle-component> s'il en a une
      // (surveillée elle aussi dès qu'elle apparaît).
      roots() {
        const roots = [this.scope];
        this.scope.querySelectorAll(MB_HOST).forEach((host) => {
          const shadow = host.shadowRoot;
          if (!shadow) return;
          if (!this.watched.has(shadow)) {
            this.watched.add(shadow);
            this.observer.observe(shadow, OBSERVE);
          }
          roots.push(shadow);
        });
        return roots;
      }

      // Offre sélectionnée : la classe documentée par Moonbundle ; à défaut, l'offre dont le bouton
      // radio est coché (même module, balisage d'une autre version).
      activeOption(box) {
        const active = box.querySelector(MB_ACTIVE) || box.querySelector(MB_ACTIVE_LOOSE);
        if (active) return active;
        for (const option of box.querySelectorAll(MB_OPTION)) {
          if (option.matches(MB_CHECKED) || option.querySelector(MB_CHECKED)) return option;
        }
        return null;
      }

      // Prix de l'offre choisie, en centimes.
      // base : prix de la variante rendu en Liquid ; limit : montant maximal jugé plausible
      // (0 = pas de limite).
      // Renvoie null sans module d'offres, { source: 'en-attente' } si le module est affiché mais
      // qu'aucun prix fiable ne peut être lu.
      readOffer(base, limit) {
        const plausible = (cents) => Boolean(cents) && (!limit || cents <= limit);
        let widget = false;

        for (const root of this.roots()) {
          const box = root.querySelector(MB_BOX);
          if (!box) continue;
          widget = true;
          const active = this.activeOption(box);
          if (!active) continue;
          // Le bloc de prix est normalement dans la ligne de l'offre ; sinon, dans l'enveloppe de
          // cette seule offre. Le prix barré et les prix unitaires peuvent porter aussi la classe
          // du bloc de prix : pick() les écarte.
          const zone = pick(active, MB_PRICE, NOT_MAIN) ? active : active.closest(MB_WRAPPER) || active;
          const block = pick(zone, MB_PRICE, NOT_MAIN);
          if (!block) continue;
          const main = block.cloneNode(true);
          main.querySelectorAll(NOT_MAIN).forEach((node) => node.remove());
          const price = firstAmount(main.textContent, this.patterns);
          if (!plausible(price)) continue;
          const old = pick(block, MB_OLD, MB_PER_UNIT) || pick(zone, MB_OLD, MB_PER_UNIT);
          const compare = old ? firstAmount(old.textContent, this.patterns) : null;
          return { source: 'offre', price: price, compare: plausible(compare) ? compare : null };
        }

        if (!widget) return null;

        // Module affiché mais illisible : le prix du thème ne vaut que s'il est synchronisé par
        // Moonbundle. Sinon il reste au prix d'une boîte, quelle que soit l'offre choisie.
        const themePrice = this.scope.querySelector(THEME_PRICE);
        const price = themePrice ? firstAmount(themePrice.textContent, this.patterns) : null;
        if (plausible(price) && base && price !== base) this.themeSynced = true;
        if (plausible(price) && this.themeSynced) {
          const themeCompare = this.scope.querySelector(THEME_COMPARE);
          const compare = themeCompare ? firstAmount(themeCompare.textContent, this.patterns) : null;
          return { source: 'prix-du-theme', price: price, compare: plausible(compare) ? compare : null };
        }
        return { source: 'en-attente', price: null, compare: null };
      }

      update() {
        const button = this.host && this.host.querySelector('[ref="addToCartButton"]');
        const pill = button && button.querySelector('.nf-atc__pill');
        const amount = pill && pill.querySelector('.nf-atc__amount');
        if (!amount) return;

        const base = firstAmount(clean(pill.dataset.nfBasePrice), this.patterns);
        const limit = base ? base * MAX_RATIO : 0;
        let offer = this.readStore(limit) || this.readOffer(base, limit);
        // Module présent mais état pas encore prêt : pastille masquée plutôt que le prix d'une boîte.
        if (!offer && this.storeHosts().length && (this.storeId || this.storeTries < STORE_TRIES)) {
          offer = { source: 'en-attente', price: null, compare: null };
        }
        const source = offer ? offer.source : 'variante';
        let priceText = '';
        let compareText = '';
        if (offer && offer.price) {
          priceText = formatMoney(offer.price, this.format);
          if (pill.dataset.nfShowCompare === 'true' && offer.compare && offer.compare > offer.price) {
            compareText = formatMoney(offer.compare, this.format);
          }
        } else if (!offer) {
          priceText = clean(pill.dataset.nfBasePrice);
          compareText = clean(pill.dataset.nfBaseCompare);
          if (!priceText) return;
        }

        // En attente (priceText vide) : la feuille de style masque la pastille via data-nf-source ;
        // son contenu n'est pas touché, et le bouton perd seulement nf-atc--has-compare.
        if (priceText) {
          if (amount.textContent.trim() !== priceText) amount.textContent = priceText;

          let was = pill.querySelector('.nf-atc__was');
          if (compareText) {
            if (!was) {
              was = document.createElement('s');
              was.className = 'nf-atc__was';
              pill.insertBefore(was, amount);
            }
            if (was.textContent.trim() !== compareText) was.textContent = compareText;
          } else if (was) {
            was.remove();
          }
        }

        const hasCompare = compareText !== '';
        if (button.classList.contains('nf-atc--has-compare') !== hasCompare) {
          button.classList.toggle('nf-atc--has-compare', hasCompare);
        }

        if (pill.dataset.nfSource !== source) pill.dataset.nfSource = source;
      }
    }

    customElements.define('nf-atc-offer-sync', NfAtcOfferSync);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nf-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nf-delivery-estimate')) {
    class NfDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        this.render = this.render.bind(this);
        this.render();

        /* Un re-rendu par « morph » (changement de variante) peut remettre le texte de repli : on recalcule. */
        if ('MutationObserver' in window && !this.observer) {
          this.observer = new MutationObserver(() => {
            const target = this.querySelector('[data-nf-delivery-text]');
            if (!target || !this.signature) return;
            if (target.dataset.nfSignature !== this.signature || target.textContent !== this.expectedText) this.render();
          });
          this.observer.observe(this, { childList: true, subtree: true, characterData: true, attributes: true });
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.observer = null;
      }

      static isWeekend(date) {
        const day = date.getDay();
        return day === 0 || day === 6;
      }

      static addDays(from, days, skipWeekends) {
        const date = new Date(from.getTime());
        let remaining = days;
        while (remaining > 0) {
          date.setDate(date.getDate() + 1);
          if (skipWeekends && NfDeliveryEstimate.isWeekend(date)) continue;
          remaining -= 1;
        }
        return date;
      }

      number(name, fallback) {
        const value = parseInt(this.dataset[name], 10);
        return Number.isFinite(value) ? value : fallback;
      }

      render() {
        const target = this.querySelector('[data-nf-delivery-text]');
        const template = (this.dataset.template || '').trim();
        if (!target || !template) return;

        const minDays = Math.max(this.number('minDays', 2), 0);
        const maxDays = Math.max(this.number('maxDays', minDays), minDays);
        const skipWeekends = this.dataset.skipWeekends === 'true';
        const useCutoff = this.dataset.useCutoff === 'true';
        const cutoffHour = this.number('cutoffHour', 14);

        /* Jour d'expédition : aujourd'hui, ou le lendemain après l'heure limite, jamais un week-end si demandé. */
        const start = new Date();
        if (useCutoff && start.getHours() >= cutoffHour) start.setDate(start.getDate() + 1);
        if (skipWeekends) {
          while (NfDeliveryEstimate.isWeekend(start)) start.setDate(start.getDate() + 1);
        }
        start.setHours(12, 0, 0, 0);

        let formatter;
        try {
          formatter = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
        } catch (error) {
          return;
        }

        const values = {
          '{date_min}': formatter.format(NfDeliveryEstimate.addDays(start, minDays, skipWeekends)),
          '{date_max}': formatter.format(NfDeliveryEstimate.addDays(start, maxDays, skipWeekends)),
        };

        const signature = [template, values['{date_min}'], values['{date_max}']].join('|');
        const fragment = document.createDocumentFragment();
        template.split(/(\{date_min\}|\{date_max\})/g).forEach((part) => {
          if (!part) return;
          if (values[part]) {
            const strong = document.createElement('strong');
            strong.textContent = values[part];
            fragment.appendChild(strong);
          } else {
            fragment.appendChild(document.createTextNode(part));
          }
        });

        this.signature = signature;
        target.dataset.nfSignature = signature;
        target.replaceChildren(fragment);
        this.expectedText = target.textContent;
      }
    }

    customElements.define('nf-delivery-estimate', NfDeliveryEstimate);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nf-gifts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nf-gifts')) {
    class NfGifts extends HTMLElement {
      constructor() {
        super();
        this.onVariantUpdate = this.onVariantUpdate.bind(this);
      }

      connectedCallback() {
        this.host = this.closest('.shopify-section, dialog');
        if (this.host) this.host.addEventListener('variant:update', this.onVariantUpdate);
      }

      disconnectedCallback() {
        if (this.host) this.host.removeEventListener('variant:update', this.onVariantUpdate);
        this.host = null;
      }

      onVariantUpdate(event) {
        var data = event && event.detail && event.detail.data;
        if (!data || !data.html) return;
        if (data.productId && this.dataset.productId && String(data.productId) !== this.dataset.productId) return;

        var fresh = data.html.querySelector('nf-gifts[data-block-id="' + this.dataset.blockId + '"]');
        if (!fresh) return;

        var currentList = this.querySelector('.nf-gifts__list');
        var freshList = fresh.querySelector('.nf-gifts__list');
        if (!currentList || !freshList) return;

        if (currentList.innerHTML !== freshList.innerHTML) {
          currentList.innerHTML = freshList.innerHTML;
        }
      }
    }

    customElements.define('nf-gifts', NfGifts);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nf-offer-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nf-offer-default')) {
    /**
     * Sélectionne UNE SEULE FOIS l'offre par défaut (data-default-tier) au premier chargement :
     * - jamais s'il y a déjà ?variant= dans l'URL (choix explicite du visiteur ou lien direct) ;
     * - jamais si l'offre est indisponible ou déjà cochée ;
     * - placé hors de <variant-picker>, donc non concerné par le morph ; un drapeau global par section
     *   empêche toute boucle si l'élément est reconnecté (re-rendu de section, éditeur de thème).
     */
    class NfOfferDefault extends HTMLElement {
      connectedCallback() {
        var tier = this.dataset.defaultTier;
        if (!tier || tier === 'none') return;

        if (new URLSearchParams(window.location.search).has('variant')) return;

        var key = this.dataset.sectionId || 'default';
        window.__nfOfferDefaultDone = window.__nfOfferDefaultDone || {};
        if (window.__nfOfferDefaultDone[key]) return;
        window.__nfOfferDefaultDone[key] = true;

        var self = this;
        var host = this.closest('.shopify-section, dialog') || document;

        /* On attend aussi les éléments qui écoutent « variant:update » (formulaire d'achat, prix, cadeaux)
           s'ils sont présents : sinon l'évènement pourrait partir avant qu'ils n'écoutent, et la carte
           affichée ne correspondrait plus à la variante réellement envoyée au panier. */
        var domReady = new Promise(function (resolve) {
          if (document.readyState !== 'loading') return resolve();
          document.addEventListener('DOMContentLoaded', resolve, { once: true });
        });

        domReady.then(function () {
          var waits = [customElements.whenDefined('variant-picker')];
          ['product-form-component', 'product-price', 'nf-gifts'].forEach(function (tag) {
            if (host.querySelector(tag)) waits.push(customElements.whenDefined(tag));
          });
          return Promise.all(waits);
        }).then(function () {
          if (!self.isConnected) return;
          if (new URLSearchParams(window.location.search).has('variant')) return;

          var root = self.closest('.nf-offer-picker');
          if (!root) return;

          var input = root.querySelector('variant-picker input[type="radio"][data-nf-tier="' + tier + '"]');
          if (!input || input.checked) return;
          if (input.dataset.optionAvailable !== 'true') return;

          /* click() coche le radio et émet « change », exactement comme un clic du visiteur */
          input.click();
        });
      }
    }

    customElements.define('nf-offer-default', NfOfferDefault);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nf-stock-gauge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nf-stock-gauge')) {
    class NfStockGauge extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-animate')) return;

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || !('IntersectionObserver' in window)) return;

        // Déjà à l'écran (ou déjà jouée avant un re-rendu) : on laisse l'animation CSS se dérouler.
        const rect = this.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const onScreen = rect.height > 0 && rect.top < viewportHeight && rect.bottom > 0;
        if (onScreen || this.hasAttribute('data-visible')) return;

        this.disconnectObserver();
        this.setAttribute('data-ready', '');
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.disconnectObserver();
            requestAnimationFrame(() => this.setAttribute('data-visible', ''));
          },
          { threshold: 0.4 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.disconnectObserver();
      }

      disconnectObserver() {
        if (!this.observer) return;
        this.observer.disconnect();
        this.observer = null;
      }
    }

    customElements.define('nf-stock-gauge', NfStockGauge);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nf-video-stories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nf-story-reel')) {
    /* Une réplique par ligne : « 0.4-3.2 | texte » (virgule décimale acceptée). */
    const NF_VSB_CUE = /^\s*([\d.,]+)\s*-\s*([\d.,]+)\s*\|\s*(.+)$/;

    const nfVsbSeconds = (value) => parseFloat(String(value).replace(',', '.'));

    const nfVsbParseCaptions = (raw) => {
      if (typeof raw !== 'string' || raw.trim() === '') return [];
      const cues = [];
      raw.split(/\r?\n/).forEach((line) => {
        const match = line.match(NF_VSB_CUE);
        if (!match) return;
        const start = nfVsbSeconds(match[1]);
        const end = nfVsbSeconds(match[2]);
        const text = match[3].trim();
        if (!isFinite(start) || !isFinite(end) || end <= start || text === '') return;
        cues.push({ start, end, text });
      });
      return cues.sort((a, b) => a.start - b.start);
    };

    const nfVsbReadCaptions = (item) => {
      const node = item.querySelector('script[data-nf-captions]');
      if (!node) return [];
      try {
        return nfVsbParseCaptions(JSON.parse(node.textContent));
      } catch (error) {
        return [];
      }
    };

    const nfVsbReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const nfVsbSaveData = () => Boolean(navigator.connection && navigator.connection.saveData);
    const nfVsbQuietPlay = (video) => {
      const attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
    };

    class NfStoryReel extends HTMLElement {
      constructor() {
        super();
        [
          'onClick',
          'onScroll',
          'onBlockSelect',
          'onAnyPlay',
          'onMediaEvent',
          'onVariantUpdate',
          'onDialogClose',
          'onDialogClick',
          'onKeydown',
          'onPointerDown',
          'onPointerMove',
          'onPointerUp',
          'onPointerCancel',
          'onPlayerEvent',
          'tick',
        ].forEach((name) => {
          this[name] = this[name].bind(this);
        });
      }

      connectedCallback() {
        this.track = this.querySelector('[data-nf-track]');
        if (!this.track) return;

        /* Grille fixe : aucune rangée qui défile, donc ni flèches ni tabindex sur la liste. */
        this.isGrid = Boolean(this.closest('.nf-vsb--grid'));
        this.dialog = this.querySelector('[data-nf-dialog]');
        this.fullscreen = this.dataset.fullscreen === 'true' && Boolean(this.dialog);
        this.autoAdvance = this.dataset.autoAdvance === 'true';
        this.showCaptions = this.dataset.captions === 'true';
        this.current = -1;
        this.muted = false;
        this.bars = [];
        this.pausedByUs = [];
        this.visibleItems = new Set();
        this.inlineStory = null;
        this.ticking = false;
        this.collect();

        this.addEventListener('click', this.onClick);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        /* Les évènements média ne remontent pas : on les écoute en phase de capture. */
        ['playing', 'play', 'pause', 'ended'].forEach((type) => this.addEventListener(type, this.onMediaEvent, true));
        document.addEventListener('play', this.onAnyPlay, true);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.track);
        }

        this.section = this.closest('.shopify-section');
        if (this.section) this.section.addEventListener('variant:update', this.onVariantUpdate);

        if (this.dialog) {
          this.stage = this.dialog.querySelector('[data-nf-stage]');
          this.screen = this.dialog.querySelector('[data-nf-screen]');
          this.player = this.dialog.querySelector('[data-nf-player]');
          this.barsNode = this.dialog.querySelector('[data-nf-bars]');
          this.titleNode = this.dialog.querySelector('[data-nf-title]');
          this.captionNode = this.dialog.querySelector('[data-nf-caption]');
          this.transcriptNode = this.dialog.querySelector('[data-nf-transcript]');
          this.statusNode = this.dialog.querySelector('[data-nf-status]');
          this.toggleButton = this.dialog.querySelector('[data-nf-toggle]');
          this.muteButton = this.dialog.querySelector('[data-nf-mute]');

          this.dialog.addEventListener('close', this.onDialogClose);
          this.dialog.addEventListener('click', this.onDialogClick);
          this.dialog.addEventListener('keydown', this.onKeydown);
          if (this.screen) {
            this.screen.addEventListener('pointerdown', this.onPointerDown);
            this.screen.addEventListener('pointermove', this.onPointerMove);
            this.screen.addEventListener('pointerup', this.onPointerUp);
            this.screen.addEventListener('pointercancel', this.onPointerCancel);
          }
          if (this.player) {
            ['play', 'playing', 'pause', 'waiting', 'canplay', 'ended', 'seeked', 'loadedmetadata', 'volumechange', 'error'].forEach(
              (type) => this.player.addEventListener(type, this.onPlayerEvent)
            );
          }
        }

        this.observePreviews();
        this.update();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        ['playing', 'play', 'pause', 'ended'].forEach((type) => this.removeEventListener(type, this.onMediaEvent, true));
        document.removeEventListener('play', this.onAnyPlay, true);
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        if (this.section) this.section.removeEventListener('variant:update', this.onVariantUpdate);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.previewObserver) this.previewObserver.disconnect();
        this.resizeObserver = null;
        this.previewObserver = null;

        if (this.dialog) {
          this.dialog.removeEventListener('close', this.onDialogClose);
          this.dialog.removeEventListener('click', this.onDialogClick);
          this.dialog.removeEventListener('keydown', this.onKeydown);
          if (this.dialog.open) this.dialog.close();
        }
        this.visibleItems = new Set();
        if (this.screen) {
          this.screen.removeEventListener('pointerdown', this.onPointerDown);
          this.screen.removeEventListener('pointermove', this.onPointerMove);
          this.screen.removeEventListener('pointerup', this.onPointerUp);
          this.screen.removeEventListener('pointercancel', this.onPointerCancel);
        }
        if (this.player) {
          ['play', 'playing', 'pause', 'waiting', 'canplay', 'ended', 'seeked', 'loadedmetadata', 'volumechange', 'error'].forEach(
            (type) => this.player.removeEventListener(type, this.onPlayerEvent)
          );
        }
        this.teardown();
        this.querySelectorAll('video').forEach((video) => video.pause());
      }

      /* ---------- Données ---------- */

      collect() {
        const rootId = (this.closest('.nf-vsb') || {}).id || 'nf-vsb';
        this.stories = Array.from(this.querySelectorAll('[data-nf-story]')).map((item, index) => {
          const story = {
            item,
            card: item.querySelector('[data-nf-open]'),
            preview: item.querySelector('[data-nf-preview]'),
            srcCard: item.dataset.srcCard || '',
            srcLight: item.dataset.srcLight || '',
            lightSide: parseFloat(item.dataset.lightSide) || 0,
            srcFull: item.dataset.srcFull || item.dataset.srcCard || '',
            poster: item.dataset.posterFull || '',
            title: item.dataset.title || '',
            desc: item.dataset.desc || '',
            cues: nfVsbReadCaptions(item),
          };

          /* Sans plein écran : transcription masquée visuellement, reliée à la carte. */
          if (!this.fullscreen && story.cues.length && story.card && !item.querySelector('[data-nf-inline-transcript]')) {
            const node = document.createElement('span');
            node.className = 'nf-vsb__sr';
            node.id = rootId + '-transcript-' + index;
            node.setAttribute('data-nf-inline-transcript', '');
            node.textContent = story.cues.map((cue) => cue.text).join(' ');
            item.appendChild(node);
            const described = story.card.getAttribute('aria-describedby');
            story.card.setAttribute('aria-describedby', described ? described + ' ' + node.id : node.id);
          }
          return story;
        });
      }

      refresh() {
        if (this.dialog && this.dialog.open) return;
        this.collect();
        this.observePreviews();
        this.update();
      }

      onVariantUpdate() {
        window.requestAnimationFrame(() => this.refresh());
      }

      /* ---------- Aperçus muets dans les cartes ---------- */

      get previewsAllowed() {
        if (this.dataset.autoplayPreview !== 'true') return false;
        if (this.closest('.nf-vsb--bubbles')) return false;
        return !nfVsbReducedMotion() && !nfVsbSaveData();
      }

      observePreviews() {
        if (this.previewObserver) this.previewObserver.disconnect();
        this.previewObserver = null;
        this.visibleItems = new Set();
        if (!('IntersectionObserver' in window)) return;

        this.previewObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                this.visibleItems.add(entry.target);
              } else {
                this.visibleItems.delete(entry.target);
              }
            });
            this.syncPreviews();
          },
          { threshold: [0, 0.6, 1] }
        );
        this.stories.forEach((story) => this.previewObserver.observe(story.item));
      }

      syncPreviews() {
        const allowed = this.previewsAllowed && !(this.dialog && this.dialog.open);
        this.stories.forEach((story) => {
          const video = story.preview;
          if (!video) return;

          if (story === this.inlineStory) {
            if (!this.visibleItems.has(story.item) && !video.paused) video.pause();
            return;
          }

          if (allowed && !this.inlineStory && this.visibleItems.has(story.item) && story.srcCard) {
            if (!video.getAttribute('src')) video.setAttribute('src', this.previewSource(story));
            video.muted = true;
            video.loop = true;
            if (video.paused) nfVsbQuietPlay(video);
          } else if (!video.paused) {
            video.pause();
          }
        });
      }

      /* Aperçu muet : rendu le plus léger (480p, 270 px de large) quand il couvre la largeur réelle de la carte
         (densité d'écran plafonnée à 2), par exemple la grille fixe de 3 cartes d'environ 110 px sur mobile ;
         sinon le rendu « carte » (720p). La lecture avec le son et le plein écran ne changent pas. */
      previewSource(story) {
        if (!story.srcLight || !story.lightSide || story.srcLight === story.srcCard) return story.srcCard;
        const width = story.item.getBoundingClientRect().width;
        if (!width) return story.srcCard;
        const needed = width * Math.min(window.devicePixelRatio || 1, 2);
        return needed <= story.lightSide ? story.srcLight : story.srcCard;
      }

      onMediaEvent(event) {
        const video = event.target;
        if (!(video instanceof HTMLVideoElement) || !video.hasAttribute('data-nf-preview')) return;
        const item = video.closest('.nf-vsb__item');
        if (!item) return;

        if (event.type === 'playing') item.classList.add('is-live');

        const story = this.inlineStory;
        if (!story || story.preview !== video) return;
        if (event.type === 'play' || event.type === 'playing') {
          item.classList.add('is-playing');
          if (story.card) story.card.setAttribute('aria-pressed', 'true');
        }
        if (event.type === 'pause') {
          item.classList.remove('is-playing');
          if (story.card) story.card.setAttribute('aria-pressed', 'false');
        }
        if (event.type === 'ended') this.stopInline(true);
      }

      /* ---------- Une seule vidéo avec le son à la fois ---------- */

      pauseOthers(except) {
        document.querySelectorAll('video').forEach((video) => {
          if (video === except || video.paused) return;
          if (!(this.contains(video) && video.hasAttribute('data-nf-preview')) && video.muted) {
            this.pausedByUs.push(video);
          }
          video.pause();
        });
      }

      resumeOthers() {
        const list = this.pausedByUs;
        this.pausedByUs = [];
        list.forEach((video) => {
          if (video.isConnected && video.paused && video.muted) nfVsbQuietPlay(video);
        });
      }

      onAnyPlay(event) {
        const video = event.target;
        if (!(video instanceof HTMLVideoElement) || video.muted) return;
        if (video === this.player) return;
        if (this.inlineStory && video === this.inlineStory.preview) return;
        if (this.player && !this.player.paused) this.player.pause();
        if (this.inlineStory && this.inlineStory.preview && !this.inlineStory.preview.paused) {
          this.inlineStory.preview.pause();
        }
      }

      /* ---------- Rangée ---------- */

      onClick(event) {
        const target = event.target instanceof Element ? event.target : null;
        if (!target || (this.dialog && this.dialog.contains(target))) return;

        const opener = target.closest('[data-nf-open]');
        if (opener) {
          const index = this.stories.findIndex((story) => story.card === opener);
          if (index < 0) return;
          event.preventDefault();
          if (this.fullscreen) {
            this.open(index, opener);
          } else {
            this.toggleInline(this.stories[index]);
          }
          return;
        }

        if (target.closest('[data-nf-prev]')) this.scrollByCard(-1);
        if (target.closest('[data-nf-next]')) this.scrollByCard(1);
      }

      scrollByCard(direction) {
        const item = this.track.querySelector('.nf-vsb__item');
        const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
        const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
        this.track.scrollBy({ left: direction * step, behavior: nfVsbReducedMotion() ? 'auto' : 'smooth' });
      }

      onBlockSelect(event) {
        if (this.dialog && this.dialog.open) this.close();
        const item = event.target instanceof Element ? event.target.closest('.nf-vsb__item') : null;
        if (!item || this.isGrid || this.track.scrollWidth - this.track.clientWidth <= 2) return;
        const gutter = parseFloat(window.getComputedStyle(this.track).paddingLeft) || 0;
        const delta = item.getBoundingClientRect().left - this.track.getBoundingClientRect().left - gutter;
        this.track.scrollBy({ left: delta, behavior: 'auto' });
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      }

      update() {
        if (!this.track || !this.track.isConnected) return;
        if (this.isGrid) {
          this.track.removeAttribute('tabindex');
          const gridNav = this.querySelector('[data-nf-nav]');
          if (gridNav) gridNav.hidden = true;
          return;
        }
        const max = this.track.scrollWidth - this.track.clientWidth;
        const overflowing = max > 2;

        if (overflowing) {
          this.track.setAttribute('tabindex', '0');
        } else {
          this.track.removeAttribute('tabindex');
        }

        const nav = this.querySelector('[data-nf-nav]');
        if (!nav) return;
        nav.hidden = !overflowing;
        const prev = nav.querySelector('[data-nf-prev]');
        const next = nav.querySelector('[data-nf-next]');
        if (prev) prev.disabled = this.track.scrollLeft <= 2;
        if (next) next.disabled = this.track.scrollLeft >= max - 2;
      }

      /* ---------- Lecture dans la carte (plein écran désactivé) ---------- */

      toggleInline(story) {
        const video = story.preview;
        if (!video || !story.srcCard) return;

        if (this.inlineStory === story && !video.paused && !video.ended) {
          video.pause();
          return;
        }
        if (this.inlineStory && this.inlineStory !== story) this.stopInline(false);

        this.inlineStory = story;
        this.syncPreviews();
        if (video.getAttribute('src') !== story.srcCard) video.setAttribute('src', story.srcCard);
        if (video.dataset.mode !== 'sound') {
          video.dataset.mode = 'sound';
          try {
            video.currentTime = 0;
          } catch (error) {
            /* Métadonnées pas encore chargées : la lecture partira du début. */
          }
        }
        video.loop = false;
        video.muted = false;
        this.pauseOthers(video);
        story.item.classList.add('is-playing');
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(() => this.stopInline(false));
      }

      stopInline(rewind) {
        const story = this.inlineStory;
        this.inlineStory = null;
        if (!story) return;
        story.item.classList.remove('is-playing');
        if (story.card) story.card.setAttribute('aria-pressed', 'false');
        const video = story.preview;
        if (video) {
          video.pause();
          video.muted = true;
          video.loop = true;
          delete video.dataset.mode;
          if (rewind) {
            try {
              video.currentTime = 0;
            } catch (error) {
              /* Sans conséquence. */
            }
          }
        }
        this.syncPreviews();
      }

      /* ---------- Plein écran façon story ---------- */

      open(index, opener) {
        if (!this.dialog || !this.player || !this.stories[index]) return;
        this.opener = opener || null;
        this.buildBars();

        if (!this.dialog.open) {
          this.pauseOthers(this.player);
          document.documentElement.classList.add('nf-vsb-lock');
          try {
            this.dialog.showModal();
          } catch (error) {
            this.dialog.setAttribute('open', '');
          }
          this.syncPreviews();
        }

        this.show(index);
        this.startTick();
      }

      buildBars() {
        if (!this.barsNode) return;
        if (this.bars.length === this.stories.length && this.bars.every((bar) => bar.isConnected)) return;
        this.barsNode.textContent = '';
        this.bars = this.stories.map(() => {
          const bar = document.createElement('span');
          bar.className = 'nf-vsb__bar';
          const fill = document.createElement('span');
          fill.className = 'nf-vsb__bar-fill';
          bar.appendChild(fill);
          this.barsNode.appendChild(bar);
          return bar;
        });
      }

      setFill(index, value) {
        const bar = this.bars[index];
        if (bar) bar.style.setProperty('--nf-fill', String(value));
      }

      show(index) {
        const story = this.stories[index];
        const player = this.player;
        if (!story || !player) return;

        this.current = index;
        this.cue = null;
        this.renderCaption('');

        player.pause();
        if (story.poster) {
          player.setAttribute('poster', story.poster);
        } else {
          player.removeAttribute('poster');
        }
        player.setAttribute('src', story.srcFull);
        player.muted = this.muted;
        player.setAttribute('aria-label', story.desc || story.title || this.dialog.getAttribute('aria-label') || '');

        if (this.titleNode) this.titleNode.textContent = story.title;
        if (this.transcriptNode) this.transcriptNode.textContent = story.cues.map((cue) => cue.text).join(' ');
        if (this.statusNode) {
          this.statusNode.textContent = index + 1 + ' / ' + this.stories.length + (story.title ? ' : ' + story.title : '');
        }
        this.bars.forEach((bar, i) => bar.style.setProperty('--nf-fill', i < index ? '1' : '0'));

        this.play();
        this.syncMute();
        this.syncState();
      }

      play() {
        const player = this.player;
        if (!player || !player.getAttribute('src')) return;
        if (player.ended) {
          try {
            player.currentTime = 0;
          } catch (error) {
            /* Sans conséquence. */
          }
        }
        this.pauseOthers(player);
        const attempt = player.play();
        if (!attempt || typeof attempt.catch !== 'function') return;
        attempt.catch((error) => {
          /* Son refusé par le navigateur : on relance sans le son, le bouton permet de le réactiver. */
          if (error && error.name === 'NotAllowedError' && !player.muted) {
            player.muted = true;
            this.muted = true;
            this.syncMute();
            const retry = player.play();
            if (retry && typeof retry.catch === 'function') retry.catch(() => this.syncState());
          } else {
            this.syncState();
          }
        });
      }

      toggle() {
        if (!this.player) return;
        if (this.player.paused || this.player.ended) {
          this.play();
        } else {
          this.player.pause();
        }
      }

      next() {
        if (this.current < this.stories.length - 1) {
          this.show(this.current + 1);
        } else {
          this.close();
        }
      }

      prev() {
        if (this.current > 0) {
          this.show(this.current - 1);
          return;
        }
        try {
          this.player.currentTime = 0;
        } catch (error) {
          /* Sans conséquence. */
        }
        this.play();
      }

      toggleMute() {
        this.muted = !(this.player ? this.player.muted : this.muted);
        if (this.player) this.player.muted = this.muted;
        this.syncMute();
      }

      syncMute() {
        if (!this.muteButton) return;
        const muted = this.player ? this.player.muted : this.muted;
        this.muteButton.classList.toggle('is-muted', muted);
        const label = muted ? this.muteButton.dataset.labelUnmute : this.muteButton.dataset.labelMute;
        if (label) this.muteButton.setAttribute('aria-label', label);
      }

      syncState() {
        if (!this.stage || !this.player) return;
        const paused = this.player.paused || this.player.ended;
        this.stage.classList.toggle('is-paused', paused);
        if (this.toggleButton) {
          const label = paused ? this.toggleButton.dataset.labelPlay : this.toggleButton.dataset.labelPause;
          if (label) this.toggleButton.setAttribute('aria-label', label);
        }
      }

      onPlayerEvent(event) {
        if (!this.dialog || !this.dialog.open) return;
        switch (event.type) {
          case 'ended':
            this.setFill(this.current, 1);
            this.renderCaption('');
            if (this.autoAdvance && !nfVsbReducedMotion() && this.current < this.stories.length - 1) {
              this.show(this.current + 1);
              return;
            }
            break;
          case 'waiting':
            this.stage.classList.add('is-waiting');
            break;
          case 'playing':
          case 'canplay':
          case 'pause':
          case 'error':
            this.stage.classList.remove('is-waiting');
            break;
          case 'volumechange':
            this.muted = this.player.muted;
            this.syncMute();
            return;
          default:
            break;
        }
        this.syncState();
        this.render();
      }

      startTick() {
        if (!this.raf) this.raf = window.requestAnimationFrame(this.tick);
      }

      stopTick() {
        if (this.raf) window.cancelAnimationFrame(this.raf);
        this.raf = 0;
      }

      tick() {
        this.raf = 0;
        if (!this.dialog || !this.dialog.open) return;
        this.render();
        this.raf = window.requestAnimationFrame(this.tick);
      }

      render() {
        const player = this.player;
        const story = this.stories[this.current];
        if (!player || !story) return;

        const time = player.currentTime || 0;
        const duration = player.duration;
        if (!player.ended) {
          this.setFill(this.current, duration && isFinite(duration) ? Math.min(time / duration, 1) : 0);
        }

        if (!this.showCaptions) return;
        const cue = player.ended ? null : story.cues.find((item) => time >= item.start && time < item.end) || null;
        if (cue !== this.cue) {
          this.cue = cue;
          this.renderCaption(cue ? cue.text : '');
        }
      }

      renderCaption(text) {
        if (!this.captionNode) return;
        const span = this.captionNode.firstElementChild;
        if (span) span.textContent = text;
        this.captionNode.hidden = !text;
      }

      close() {
        if (this.dialog && this.dialog.open) this.dialog.close();
        this.teardown();
      }

      onDialogClose() {
        this.teardown();
        const opener = this.opener;
        this.opener = null;
        if (opener && opener.isConnected) {
          try {
            opener.focus({ preventScroll: true });
          } catch (error) {
            opener.focus();
          }
        }
      }

      /* Remise à zéro idempotente (fermeture, Échap, re-rendu dans l'éditeur). */
      teardown() {
        this.stopTick();
        this.gesture = null;
        window.clearTimeout(this.holdTimer);
        document.documentElement.classList.remove('nf-vsb-lock');

        if (this.player && this.player.getAttribute('src')) {
          this.player.pause();
          this.player.removeAttribute('src');
          this.player.removeAttribute('poster');
          try {
            this.player.load();
          } catch (error) {
            /* Sans conséquence. */
          }
        }
        if (this.stage) this.stage.classList.remove('is-waiting', 'is-paused');
        this.current = -1;
        this.cue = null;
        this.renderCaption('');
        this.stopInline(false);
        this.resumeOthers();
        this.syncPreviews();
      }

      onDialogClick(event) {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        if (target === this.dialog) {
          /* Clic sur le fond autour de la vidéo (ordinateur), hors fin de balayage. */
          if (performance.now() - (this.lastGesture || 0) > 400) this.close();
          return;
        }
        if (target.closest('[data-nf-close]')) {
          this.close();
          return;
        }
        if (target.closest('[data-nf-toggle]')) {
          this.toggle();
          return;
        }
        if (target.closest('[data-nf-mute]')) {
          this.toggleMute();
          return;
        }
        const step = target.closest('[data-nf-step]');
        if (step) {
          if (Number(step.getAttribute('data-nf-step')) > 0) {
            this.next();
          } else {
            this.prev();
          }
          return;
        }
        const cta = target.closest('[data-nf-cta]');
        if (cta) this.onCta(event, cta);
      }

      onCta(event, link) {
        const href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#') {
          this.close();
          return;
        }
        event.preventDefault();
        let destination = null;
        try {
          destination = document.getElementById(decodeURIComponent(href.slice(1)));
        } catch (error) {
          destination = null;
        }
        this.close();
        if (!destination) return;
        window.requestAnimationFrame(() => {
          destination.scrollIntoView({ behavior: nfVsbReducedMotion() ? 'auto' : 'smooth', block: 'start' });
        });
      }

      onKeydown(event) {
        if (!this.dialog.open) return;
        const onControl = event.target instanceof Element && event.target.closest('button, a');
        switch (event.key) {
          case 'ArrowRight':
            event.preventDefault();
            this.next();
            break;
          case 'ArrowLeft':
            event.preventDefault();
            this.prev();
            break;
          case ' ':
          case 'Spacebar':
            if (onControl) return;
            event.preventDefault();
            this.toggle();
            break;
          case 'k':
          case 'K':
            this.toggle();
            break;
          case 'm':
          case 'M':
            this.toggleMute();
            break;
          default:
            break;
        }
      }

      /* Appui sur le tiers gauche / droit, balayage horizontal, balayage vers le bas pour fermer,
         appui long pour mettre en pause le temps de l'appui. */
      onPointerDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.target instanceof Element && event.target.closest('button, a')) return;
        this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, moved: false, held: false };
        try {
          this.screen.setPointerCapture(event.pointerId);
        } catch (error) {
          /* Sans conséquence. */
        }
        window.clearTimeout(this.holdTimer);
        this.holdTimer = window.setTimeout(() => {
          const gesture = this.gesture;
          if (!gesture || gesture.moved || !this.player || this.player.paused) return;
          gesture.held = true;
          this.player.pause();
        }, 350);
      }

      onPointerMove(event) {
        const gesture = this.gesture;
        if (!gesture || event.pointerId !== gesture.id) return;
        if (Math.abs(event.clientX - gesture.x) > 10 || Math.abs(event.clientY - gesture.y) > 10) {
          gesture.moved = true;
          window.clearTimeout(this.holdTimer);
        }
      }

      onPointerUp(event) {
        const gesture = this.gesture;
        if (!gesture || event.pointerId !== gesture.id) return;
        this.gesture = null;
        window.clearTimeout(this.holdTimer);
        this.lastGesture = performance.now();

        if (gesture.held) {
          this.play();
          return;
        }

        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          if (dx < 0) {
            this.next();
          } else {
            this.prev();
          }
          return;
        }
        if (dy > 90 && dy > Math.abs(dx) * 1.2) {
          this.close();
          return;
        }
        if (gesture.moved) return;

        const rect = this.screen.getBoundingClientRect();
        const ratio = (event.clientX - rect.left) / (rect.width || 1);
        if (ratio < 1 / 3) {
          this.prev();
        } else if (ratio > 2 / 3) {
          this.next();
        } else {
          this.toggle();
        }
      }

      onPointerCancel() {
        const gesture = this.gesture;
        this.gesture = null;
        window.clearTimeout(this.holdTimer);
        if (gesture && gesture.held) this.play();
      }
    }

    customElements.define('nf-story-reel', NfStoryReel);
  }
  } catch(e) { console.error(e); }
})();

})();
